<div id="notificationwatchlist" class="subBlockContainer entry-loader">
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="cartBar page-title-wrapper" style="font-weight: 100;">
        {{title}}
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="top-divider"></div>

      <div class="shared-outer-wrapper" style="margin-bottom: 23px;">
        <table id="cartTable" class="white">
          <thead>
            <tr class="row cart-title-wrapper">
              <th style="width: 20%;padding-left: 15px">STOCK CODE</th>
              <th style="width: 50%">DESCRIPTION</th>
              <th style="width: 15%">SOH</th>
              <th style="width: 15%">PRICE</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row product-wrapper product-content-wrapper">
              <div style="width: 20%;padding-left: 15px;">
                <div>{{product?.out_stock_code}}</div>
              </div>
              <div style="width: 50%;">
                <div class="result_desc">{{product?.out_description}}</div>
              </div>
              <div style="width: 15%;">
                {{product?.out_avail_stock_qty  | number: '.0-0'}}
              </div>
              <div style="width: 15%;">
                {{product?.out_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}
              </div>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="shared-outer-wrapper">
        <table id="cartTable" class="white">
          <thead>
            <tr class="row cart-title-wrapper">
              <th style="width: 30%;padding-left: 15px">DESCRIPTION</th>
              <th style="width: 25%">CONDITION</th>
              <th style="width: 25%">VALUE</th>
              <th style="width: 10%">EMAIL</th>
              <th style="width: 10%">ALERT</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row product-wrapper product-content-wrapper">
              <div style="width: 30%;padding-left: 15px;padding-top: 20px;">
                <div>Notify me if stock on hand is</div>
              </div>
              <div style="width: 25%;">
                <ng-select class="customDropdwon" [items]="sohConditionList" bindValue="value" bindLabel="label"
                  [(ngModel)]="sohCondition"></ng-select>
              </div>
              <div style="width: 25%;">
                <mat-form-field class="example-full-width">
                  <input id="sohValue" matInput [(ngModel)]="sohValue" (keypress)="isNumberKey($event)">
                </mat-form-field>
              </div>
              <div style="width: 10%;padding-top: 20px;" class="master-tooltip" title="Email me when condition is met">
                <mat-checkbox [(ngModel)]="sohEmail"></mat-checkbox>
              </div>
              <div style="width: 10%;padding-top: 20px;" class="master-tooltip" title="Alert me on login when condition is met">
                <mat-checkbox [(ngModel)]="sohAlert"></mat-checkbox>
              </div>
            </tr>

            <tr class="row product-wrapper product-content-wrapper">
              <div style="width: 30%;padding-left: 15px;padding-top: 20px;">
                <div>Notify me if price is</div>
              </div>
              <div style="width: 25%;">
                <ng-select class="customDropdwon" [items]="sohPriceList" bindValue="value" bindLabel="label"
                  [(ngModel)]="priceCondition"></ng-select>
              </div>
              <div style="width: 25%;">
                <mat-form-field class="example-full-width">
                  <input id="priceValue" matInput [(ngModel)]="priceValue" (keypress)="isNumberKey($event)">
                </mat-form-field>
              </div>
              <div style="width: 10%;padding-top: 20px;" class="master-tooltip" title="Email me when condition is met">
                <mat-checkbox [(ngModel)]="priceEmail"></mat-checkbox>
              </div>
              <div style="width: 10%;padding-top: 20px;" class="master-tooltip" title="Alert me on login when condition is met">
                <mat-checkbox [(ngModel)]="priceAlert"></mat-checkbox>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
    <div class="notify-button">
      <div class="button button-red button-mid" (click)="saveNotification(product)">
        Save </div>
      <div class="button button-red button-mid"
        (click)="deleteNotification(product?.out_stock_code)">
        Remove All </div>
    </div>
  </div>
</div>